import actions from '@/store/modules/service/actions'
import getters from '@/store/modules/service/getters'
import mutations from '@/store/modules/service/mutations'
import state from '@/store/modules/service/state'

export default {
    actions,
    getters,
    mutations,
    state
}